import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function Calendar(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (

    <Svg 
      {...svgProps}
      viewBox="0 0 20 15">
      <G fill="#fff">
        <Path d="m2 1c-0.5523 0-1 0.4477-1 1v11c0 0.55228 0.44772 1 1 1h16c0.55228 0 1-0.44772 1-1v-11c0-0.5523-0.448-1-1-1h-16zm0-1h16c1.1046 0 2 0.89543 2 2v11c0 1.1046-0.89543 2-2 2h-16c-1.1046 0-2-0.895-2-2v-11c0-1.1046 0.89543-2 2-2z"/>
        <Path d="m20 5v1h-20v-1z"/>
        <Path d="m4 4.25c-0.6904 0-1.25-0.5596-1.25-1.25s0.5596-1.25 1.25-1.25 1.25 0.5596 1.25 1.25-0.5596 1.25-1.25 1.25zm0-0.5c0.4142 0 0.75-0.3358 0.75-0.75s-0.3358-0.75-0.75-0.75-0.75 0.3358-0.75 0.75 0.3358 0.75 0.75 0.75z"/>
        <Path d="m16 4.25c-0.69036 0-1.25-0.55964-1.25-1.25s0.55964-1.25 1.25-1.25 1.25 0.55964 1.25 1.25-0.55964 1.25-1.25 1.25zm0-0.5c0.41421 0 0.75-0.33579 0.75-0.75s-0.33579-0.75-0.75-0.75-0.75 0.33579-0.75 0.75 0.33579 0.75 0.75 0.75z"/>
      </G>
    </Svg>

  );
}

Calendar.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

Calendar.defaultProps = {
  height: 15,
  width: 15,
};

export default pure(Calendar);